import * as React from "react";
// import { Link } from "gatsby";
// import function to register Swiper custom elements
// register Swiper custom elements
import * as styles from "./sectionWrapper.module.css";

const SectionWrapper = ({ children, style, reversed, className = "" }) => {
  const revesedStyle = reversed
    ? styles.section_wrapper + " " + styles.reversed
    : styles.section_wrapper;

  return (
    <>
      <section style={style} className={`${className} ${revesedStyle}`}>
        {children}
      </section>
    </>
  );
};
export default SectionWrapper;
